import {StudyRecap} from "./Parser";
import {CDUploadDataOverridingMetadata} from "../types/Session";

export type StudyMismatch = {
	PatientName: boolean;
	PatientBirthDate: boolean;
	PatientSex: boolean;
};

export class Mismatch {

	static compute(requestData: CDUploadDataOverridingMetadata | undefined, parsedStudies: Map<string, StudyRecap>): Map<string, StudyMismatch> {
		const diffs = new Map<string, StudyMismatch>();
		if (!requestData) {
			return diffs;
		}

		for (const [studyKey, recap] of parsedStudies.entries()) {
			let diffFound = false;
			const diff: StudyMismatch = {
				PatientName: false,
				PatientBirthDate: false,
				PatientSex: false,
			};

			for (const tag of Object.keys(diff)) {
				const overridingValue = requestData[tag as keyof CDUploadDataOverridingMetadata];
				const recapValue = recap[tag as keyof StudyRecap];
				if (overridingValue !== null && recapValue !== null && overridingValue !== recapValue) {
					diff[tag as keyof StudyMismatch] = true;
					diffFound = true;
				}
			}

			if (diffFound) {
				diffs.set(studyKey, diff);
			}
		}

		return diffs;
	}
}
